module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="col-xs-4 col-sm-4">\n    <label>' +
((__t = (data.amountLabel)) == null ? '' : __t) +
'</label>\n</div>\n<div class="col-xs-6 col-sm-6 toggle-amount-type">\n    <input type="radio" name="' +
((__t = (data.pickerRoot)) == null ? '' : __t) +
'amount_type" data-type="exact" id="' +
((__t = (data.pickerRoot)) == null ? '' : __t) +
'amount_type_exact"  ';
 if (data.isExact) { ;
__p += 'checked';
 } ;
__p += '  value="exact"><label for="' +
((__t = (data.pickerRoot)) == null ? '' : __t) +
'amount_type_exact">Exact amount</label>\n    <input type="radio" name="' +
((__t = (data.pickerRoot)) == null ? '' : __t) +
'amount_type" data-type="range" id="' +
((__t = (data.pickerRoot)) == null ? '' : __t) +
'amount_type_range" ';
 if (data.isRange) { ;
__p += 'checked';
 } ;
__p += '  value="range"><label for="' +
((__t = (data.pickerRoot)) == null ? '' : __t) +
'amount_type_range">Range</label>\n    <input name="' +
((__t = (data.pickerRoot)) == null ? '' : __t) +
'amount" type="hidden" class="val">\n</div>\n<div class="offset-xs-4 offset-sm-4 col-xs-4 col-sm-4"></div>\n<div class="col-xs-4 col-sm-4 amount-inputs">\n    <div><input class="form-control lower-limit-input" ';
 if (data.isExact) { ;
__p += ' placeholder="0' +
((__t = ( data.decimalSeparator )) == null ? '' : __t) +
'00"';
 } ;
__p += ' ';
 if (data.isRange) { ;
__p += ' placeholder="No lower limit"';
 } ;
__p += '><i class="fas fa-times-circle clear-amount-icon ' +
((__t = (data.showClearLower)) == null ? '' : __t) +
'"></i></div>\n    <div><input class="form-control upper-limit-input" placeholder="No upper limit"><i class="fas fa-times-circle clear-amount-icon ' +
((__t = (data.showClearUpper)) == null ? '' : __t) +
'"></i></div>\n    <input name="' +
((__t = (data.pickerRoot)) == null ? '' : __t) +
'amount" type="hidden" class="val" value="' +
((__t = (data.inputval)) == null ? '' : __t) +
'">\n</div>\n<div class="col-xs-2 col-sm-2">\n    <div class="' +
((__t = (data.pickerRoot)) == null ? '' : __t) +
'currency input-group-btn"></div>\n</div>\n\n';
return __p
}